<template>
    <div class="admin-panel-header pos-relative dis-flex">
        <div class="header-sides-content dis-flex flex-m">
            <div class="sidebar-maximize-btn dis-flex flex-c flex-m trans-04" id="max-btn" onclick="showSidebar()">
                <div class="uim-svg">
                    <svg viewBox="0 0 24 24" width="1em">
                        <path class="uim-tertiary" d="M21 7H3A1 1 0 0 1 3 5H21a1 1 0 0 1 0 2zM21 11H3A1 1 0 0 1 3 9H21a1 1 0 0 1 0 2zM21 15H3a1 1 0 0 1 0-2H21a1 1 0 0 1 0 2zM21 19H3a1 1 0 0 1 0-2H21a1 1 0 0 1 0 2z"></path>
                    </svg>
                </div>
            </div>
            <div class="admin-header-containter">
                <nav aria-label="breadcrumbs">
                    <ol class="admin-header-breadcrumb">
                        <li class="breadcrumb-item">Section</li>
                        <li class="breadcrumb-item" id="pageName">{{ $store.state.menuControl.selectedPageDisplayName }}</li>
                    </ol>
                </nav>
            </div>
        </div>
        <div class="admin-panel-headr-nav dis-flex flex-m">
            <div class="admin-panel-header-cat-icon dis-flex flex-m flex-c" @click="$refs.rightUserSideBar.rightSideBarOpened = true">
                <div class="uim-svg fs-19">
                    <svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="1em">
                        <path class="uim-tertiary" d="M12,14c-3.31371,0-6-2.68629-6-6s2.68629-6,6-6s6,2.68629,6,6C17.99638,11.31221,15.31221,13.99638,12,14z"></path>
                        <path class="uim-primary" d="M15.70056,12.71338C14.68073,13.5155,13.39789,13.99847,12,14c-1.39984,0-2.68463-0.48334-3.70532-1.28693c-3.31274,1.32574-5.80756,4.38422-6.22925,8.17853c-0.05969,0.54901,0.33679,1.04248,0.88574,1.10254L20.93945,22c0.03656,0,0.07306-0.00201,0.10938-0.00586c0.54895-0.06006,0.94543-0.55353,0.88574-1.10254C21.51917,17.15436,19.06299,14.05371,15.70056,12.71338z"></path>
                    </svg>
                </div>
            </div>
            <div class="admin-panel-header-cat-icon dis-flex flex-m flex-c pos-relative notification-on" @click="$refs.rightSideBar.rightSideBarOpened = true">
                <div class="uim-svg fs-19">
                    <svg viewBox="0 0 24 24" width="1em">
                        <rect width="9" height="9" x="2" y="2" class="uim-primary" rx="1"></rect>
                        <rect width="9" height="9" x="2" y="13" class="uim-tertiary" rx="1"></rect>
                        <rect width="9" height="9" x="13" y="2" class="uim-tertiary" rx="1"></rect>
                        <rect width="9" height="9" x="13" y="13" class="uim-tertiary" rx="1"></rect>
                    </svg>
                </div>
            </div>

            <right-side-bar ref="rightSideBar"></right-side-bar>
            <right-user-side-bar ref="rightUserSideBar"></right-user-side-bar>
        </div>
    </div>
</template>

<script>
import rightSideBarVue from "./headerBlock/rightSideBar.vue"
import rightUserSideBarVue from "./headerBlock/rightUserSideBar.vue"

export default {
    components: {
        rightSideBar: rightSideBarVue,
        rightUserSideBar: rightUserSideBarVue
    }
}
</script>

<style>

</style>